import { Tooltip } from '@digibee/beehive-ui';
import { HelpCircle } from 'iconoir-react';
import { FC, ReactNode } from 'react';

import * as Elements from './HelpText.elements';

const HelpText: FC<{ text: string; children: ReactNode }> = ({
  text,
  children
}) => (
  <Elements.Container data-testid='help-text-container'>
    {children}
    <Tooltip
      align='start'
      content={text}
      side='bottom'
      data-testid='help-text-tooltip'
    >
      <HelpCircle data-testid='help-text-icon' />
    </Tooltip>
  </Elements.Container>
);

export default HelpText;
